<template lang="pug">
  booking-form(
    @save="editBooking",
    @cancel="cancelEditBooking",
    @delete="deleteBooking",
    v-loading.fullscreen.lock="fullscreenLoading",
    :booking="booking"
    type="edit",
  )
</template>

<style lang="scss" scoped>
</style>

<script>
import BookingForm from '@/components/booking/BookingForm'
import { GenericAPIHandler } from '../shared/GenericAPIHandler'

export default {
  name: 'BookingEdit',
  mixins: [GenericAPIHandler],
  data () {
    return {
      fullscreenLoading: false,
      booking: {},
    }
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    patientId: {
      type: Number,
      required: true,
    },
    reservationId: {
      type: Number,
      required: true,
    },
  },
  mounted () {
    this.prefillEditBooking()
  },
  components: {
    BookingForm,
  },
  methods: {
    async prefillEditBooking () {
      try {
        this.fullscreenLoading = true
        this.booking = await this.$api.Booking.prepareUpdate(this.id)
      } catch (error) {
        this.showErrorDialog(error)
      } finally {
        this.fullscreenLoading = false
      }
    },
    cancelEditBooking () {
      this.$router.push({ name: 'PatientDetail', params: { id: this.patientId }, query: { tab: 'workcalendarTab' } })
    },
    async deleteBooking () {
      try {
        await this.$api.Booking.remove(this.id)
        this.$alert('เย่ ลบการหาคนเรียบร้อย', 'สำเร็จ', {
          confirmButtonText: 'OK',
          callback: action => {
            this.$router.push({ name: 'PatientDetail', params: { id: this.patientId }, query: { tab: 'workcalendarTab' } })
          },
          type: 'success',
        })
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    async editBooking (booking) {
      try {
        this.fullscreenLoading = true
        booking.id = this.id
        await this.$api.Booking.update(booking)
        this.showSuccessDialog({ name: 'PatientDetail', params: { id: this.patientId }, query: { tab: 'workcalendarTab' } })
      } catch (error) {
        this.showErrorDialog(error)
      } finally {
        this.fullscreenLoading = false
      }
    },
  },
}
</script>
